import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import SkeletonContainer from '../../Layout/SkeletonContainer';
import List from './List';

class Handyman extends Component {
    constructor(props){
        super(props);
        this.listRef = "";
    }

    title = () => {
        const { hash, level } = this.props;
        return (
            <span>
                Handyman Report {level === "1" ? "" : "(Detailed)"}
                { level === "1"? <Link to={`/handyman/2${hash}`} className="ml-1 btn btn-danger">Deep</Link> :null}
                <ReactToPrint
                    trigger={() => <span className="ml-1 btn btn-success">Print</span>}
                    content={() => this.listRef}
                />
            </span>
        );
    }
    render(){
        const { hash, level } = this.props;

        return (
            <SkeletonContainer title={this.title}>
                <List ref={list => (this.listRef = list)} hash={hash} level={level}/>
            </SkeletonContainer>
        );
    }
}

export default connect()(Handyman);


// WEBPACK FOOTER //
// ./src/Components/App/Reports/Handyman/index.js